(function () {
	'use strict';
	$(document).ready(function () {
		// Hero section
		const playVideo = (video) => {
			video.play();
			video.classList.add('playing');
			video.parentElement.classList.add('playing');
		};

		const pauseVideo = (video) => {
			video.parentElement.classList.remove('playing');
			video.classList.remove('playing');
			video.pause();
		}

		const handleVideo = (video) => {
			if (video.paused) {
				playVideo(video);
			} else {
				pauseVideo(video);
			}
		}

		document.querySelectorAll('video').forEach((videoElement) => {
			videoElement.addEventListener('click', () => {
				handleVideo(videoElement);
			});
			videoElement.nextElementSibling.addEventListener('click', () => {
				handleVideo(videoElement);
			})
		});

		$(document).keyup(function (e) {
			if (e.key === "Escape") {
				document.querySelectorAll('video').forEach((videoElement) => {
					pauseVideo(videoElement);
				});
			}
		});
	});
}(jQuery));
